export default __webpack_public_path__ + "static/media/dreamland6.57889407.jpg";